// @ts-nocheck
const PUNCTUATION =
  '\\.,\\+\\*\\?\\$\\@\\|#{}\\(\\)\\^\\-\\[\\]\\\\/!%\'"~=<>_:;'

const TRIGGERS = ['{'].join('')

const VALID_CHARS = '[^' + TRIGGERS + PUNCTUATION + '\\s]'

const LENGTH_LIMIT = 10

export const regex = new RegExp(
  '(^|\\s|\\()(' +
    '[' +
    TRIGGERS +
    ']{1}' +
    '((?:' +
    VALID_CHARS +
    '){0,' +
    LENGTH_LIMIT +
    '})' +
    ')$',
)
